import EventsScreen from "@/screens/events/EventsScreen"

export default EventsScreen
